window.theme = window.theme || {};
initWhenVisible = function (e) {
  const o = e.threshold ? e.threshold : 0;
  new IntersectionObserver(
    (i, t) => {
      i.forEach((s) => {
        s.isIntersecting &&
          typeof e.callback == "function" &&
          (e.callback(), t.unobserve(s.target));
      });
    },
    { rootMargin: `0px 0px ${o}px 0px` }
  ).observe(e.element);
};
class n extends HTMLElement {
  constructor() {
    super(),
      (this.config = { moveTime: parseFloat(this.dataset.speed), space: 100 }),
      (this.promotion = this.querySelector(".promotion")),
      initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 600,
      });
  }
  init() {
    if (this.childElementCount === 1) {
      this.promotion.classList.add("promotion--animated");
      for (let i = 0; i < 10; i++) {
        (this.clone = this.promotion.cloneNode(!0)),
          this.clone.setAttribute("aria-hidden", !0),
          this.appendChild(this.clone);
        const t = this.clone.querySelector(".media-wrapper");
        t && t.classList.remove("loading");
      }
      const o =
        (this.promotion.clientWidth / this.config.space) * this.config.moveTime;
      this.style.setProperty("--duration", `${o}s`),
        new IntersectionObserver(
          (i, t) => {
            i.forEach((s) => {
              s.isIntersecting ? this.scrollingPlay() : this.scrollingPause();
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        ).observe(this);
    }
  }
  scrollingPlay() {
    this.classList.remove("scrolling-promotion--paused");
  }
  scrollingPause() {
    this.classList.add("scrolling-promotion--paused");
  }
}
customElements.define("scrolling-promotion", n);
